/**
 * Original practice passages, written for this tool. Bangla in the registers a
 * government computer-typing candidate faces — official letters, office orders,
 * notices, applications, news-style prose — plus general paragraphs. English
 * equivalents for office and exam practice. All self-written: the public-domain
 * literature and the gazette texts carry licence or copyright questions, so none
 * is copied.
 */

export const BANGLA_PASSAGES = [
    {
        id: 'bn-office-letter',
        title: 'দাপ্তরিক পত্র',
        genre: 'letter',
        text: 'বরাবর, উপজেলা নির্বাহী কর্মকর্তা মহোদয়। বিষয়: অফিসের কম্পিউটার মেরামতের জন্য বরাদ্দ প্রসঙ্গে। জনাব, বিনীত নিবেদন এই যে, আমাদের কার্যালয়ের দুইটি কম্পিউটার দীর্ঘদিন যাবৎ অকেজো অবস্থায় রহিয়াছে। দৈনন্দিন দাপ্তরিক কাজ সঠিকভাবে সম্পন্ন করিবার জন্য অবিলম্বে উহা মেরামত করা প্রয়োজন। অতএব, বিষয়টি বিবেচনা করিয়া প্রয়োজনীয় ব্যবস্থা গ্রহণের জন্য আপনার মর্জি হয়। বিনীত নিবেদক, কার্যালয় সহকারী।',
    },
    {
        id: 'bn-office-order',
        title: 'অফিস আদেশ',
        genre: 'order',
        text: 'অফিস আদেশ। এতদ্বারা সংশ্লিষ্ট সকলের অবগতির জন্য জানানো যাইতেছে যে, আগামী সোমবার সকাল দশ ঘটিকায় সম্মেলন কক্ষে একটি জরুরি সভা অনুষ্ঠিত হইবে। উক্ত সভায় চলতি অর্থবছরের উন্নয়ন কর্মসূচি ও বাজেট বরাদ্দ লইয়া আলোচনা করা হইবে। প্রত্যেক বিভাগের দায়িত্বপ্রাপ্ত কর্মকর্তাকে যথাসময়ে উপস্থিত থাকিবার জন্য নির্দেশ প্রদান করা হইল। কর্তৃপক্ষের আদেশক্রমে জারি করা হইল।',
    },
    {
        id: 'bn-notice',
        title: 'নোটিশ',
        genre: 'notice',
        text: 'জরুরি বিজ্ঞপ্তি। সর্বসাধারণের অবগতির জন্য জানানো যাইতেছে যে, আগামী চৌদ্দ অক্টোবর হইতে আঠারো অক্টোবর পর্যন্ত কার্যালয়ের বার্ষিক পরীক্ষা অনুষ্ঠিত হইবে। এই সময়ে সকল প্রার্থীকে নির্ধারিত সময়ের অন্তত ত্রিশ মিনিট পূর্বে পরীক্ষাকেন্দ্রে উপস্থিত হইতে হইবে। প্রবেশপত্র ও জাতীয় পরিচয়পত্র সঙ্গে আনা বাধ্যতামূলক। নির্দেশনা অমান্যকারীর প্রার্থিতা বাতিল বলিয়া গণ্য হইবে।',
    },
    {
        id: 'bn-application',
        title: 'আবেদনপত্র',
        genre: 'application',
        text: 'বরাবর, প্রধান শিক্ষক মহোদয়। বিষয়: অসুস্থতাজনিত কারণে ছুটির জন্য আবেদন। জনাব, সবিনয় নিবেদন এই যে, আমি গতকাল হইতে জ্বর ও শারীরিক দুর্বলতায় ভুগিতেছি। চিকিৎসকের পরামর্শ অনুযায়ী আমার তিন দিন সম্পূর্ণ বিশ্রামের প্রয়োজন। এমতাবস্থায় আগামী তিন দিনের ছুটি মঞ্জুর করিয়া আমাকে বাধিত করিবেন। নিবেদক, আপনার একান্ত অনুগত ছাত্র।',
    },
    {
        id: 'bn-news',
        title: 'সংবাদ অনুচ্ছেদ',
        genre: 'news',
        text: 'দেশের তথ্যপ্রযুক্তি খাতে গত কয়েক বছরে উল্লেখযোগ্য অগ্রগতি সাধিত হইয়াছে। বর্তমানে প্রত্যন্ত অঞ্চলের মানুষও মোবাইল ও ইন্টারনেটের মাধ্যমে সরকারি সেবা গ্রহণ করিতে পারিতেছেন। অনলাইনে জন্ম নিবন্ধন, পরীক্ষার ফলাফল এবং নানা দাপ্তরিক আবেদন এখন ঘরে বসিয়াই সম্পন্ন করা সম্ভব। বিশেষজ্ঞরা মনে করেন, দক্ষ জনশক্তি গড়িয়া তুলিতে পারিলে এই অগ্রগতি আরও বেগবান হইবে।',
    },
    {
        id: 'bn-general',
        title: 'সাধারণ অনুচ্ছেদ',
        genre: 'general',
        text: 'নিয়মিত অনুশীলন ছাড়া কোনো দক্ষতা অর্জন করা যায় না। টাইপিং শিখিবার ক্ষেত্রেও কথাটি সমানভাবে প্রযোজ্য। প্রথমে আঙুলগুলোকে সঠিক স্থানে রাখিয়া ধীরে ধীরে অভ্যাস করিতে হয়। গতি নয়, বরং শুরুতে নির্ভুলতার দিকে মনোযোগ দেওয়া উচিত। প্রতিদিন অল্প সময় অনুশীলন করিলে কিছুদিনের মধ্যেই চোখ না রাখিয়া দ্রুত টাইপ করা সম্ভব হইয়া ওঠে।',
    },
    {
        id: 'bn-numbers',
        title: 'সংখ্যা ও তারিখ',
        genre: 'number',
        text: 'আগামী ১৪ অক্টোবর ২০২৬ তারিখে মোট ৩৫০ জন প্রার্থীর পরীক্ষা অনুষ্ঠিত হইবে। পরীক্ষার ফি ৫৬০ টাকা এবং আবেদনের শেষ তারিখ ২৫ নভেম্বর। প্রতিটি কক্ষে ৪০ জন করিয়া প্রার্থী বসিবেন। সকাল ১০টা হইতে দুপুর ১২টা পর্যন্ত মোট ১২০ মিনিট সময় বরাদ্দ থাকিবে।',
    },
];

export const ENGLISH_PASSAGES = [
    {
        id: 'en-office-letter',
        title: 'Official letter',
        genre: 'letter',
        text: 'Dear Sir, I am writing to request repair of the two computers in our office. Both machines have not worked for several weeks, and the daily office tasks cannot be finished on time without them. I would be grateful if you could arrange the necessary funds and allow the repair to be done as soon as possible. Thank you for your kind attention to this matter. Yours faithfully, Office Assistant.',
    },
    {
        id: 'en-notice',
        title: 'Notice',
        genre: 'notice',
        text: 'This is to inform all candidates that the annual typing test will be held from the fourteenth to the eighteenth of October. Candidates must reach the centre at least thirty minutes before the time given on the admit card. The admit card and the national identity card are required, and no one will be allowed to enter without them. Anyone who fails to follow these rules may lose the chance to sit for the test.',
    },
    {
        id: 'en-general',
        title: 'General paragraph',
        genre: 'general',
        text: 'No skill can be gained without regular practice, and typing is no different. At first you should place your fingers on the home row and move slowly, with your eyes on the screen and not on the keys. Accuracy matters far more than speed in the early days. If you practise for a short while every day, within a few weeks you will be able to type quickly without looking down at all.',
    },
    {
        id: 'en-news',
        title: 'News paragraph',
        genre: 'news',
        text: 'The country has made steady progress in the field of information technology over the past few years. People in remote areas can now receive many public services through a mobile phone and the internet. Tasks such as birth registration, checking exam results and filing office applications can be done from home. Experts believe that if a skilled workforce is built, this progress will move even faster in the years ahead.',
    },
    {
        id: 'en-numbers',
        title: 'Numbers and dates',
        genre: 'number',
        text: 'On 14 October 2026 a total of 350 candidates will sit for the examination. The application fee is 560 taka and the last date to apply is 25 November. Each room will seat 40 candidates, and the test will run for 120 minutes, from 10 in the morning until 12 noon.',
    },
];

export const passagesFor = (layoutId) => (layoutId === 'english' ? ENGLISH_PASSAGES : BANGLA_PASSAGES);
